export const PerformanceLogAllTR={
PeLoID:{en:'PeLoID',cs:'PeLoID',dataType:'string',required:true},
PeLoDateTime:{en:'PeLoDateTime',cs:'PeLoDateTime',dataType:'string',required:true},
PeLoUserID:{en:'PeLoUserID',cs:'PeLoUserID',dataType:'string'},
PeLoTypeOfClient:{en:'PeLoTypeOfClient',cs:'PeLoTypeOfClient',dataType:'string',maxLength:50},
PeLoClientIPAddress:{en:'PeLoClientIPAddress',cs:'PeLoClientIPAddress',dataType:'string',maxLength:50},
PeLoClientComputerName:{en:'PeLoClientComputerName',cs:'PeLoClientComputerName',dataType:'string',maxLength:500},
PeLoClassName:{en:'PeLoClassName',cs:'PeLoClassName',dataType:'string',maxLength:150},
PeLoMethodName:{en:'PeLoMethodName',cs:'PeLoMethodName',dataType:'string',required:true,maxLength:150},
PeLoDetailDescription:{en:'PeLoDetailDescription',cs:'PeLoDetailDescription',dataType:'string',required:true},
PeLoContextInfo:{en:'PeLoContextInfo',cs:'PeLoContextInfo',dataType:'string',maxLength:2000},
PeLoLengthSec:{en:'PeLoLengthSec',cs:'PeLoLengthSec',dataType:'string',required:true},
PeLoDataSizeBytes:{en:'PeLoDataSizeBytes',cs:'PeLoDataSizeBytes',dataType:'string',required:true},
PeLoIsDataSize:{en:'PeLoIsDataSize',cs:'PeLoIsDataSize',dataType:'boolean',required:true},
UserFullName:{en:'Full Name',cs:'',dataType:'string',maxLength:101}
}